import {
  GET_SLACK_BOT_SELECT,
  SLACK_SCHEDULER_PAGE,
  PENDING_SLACK_SCHEDULER,
  GET_SLACK_SCHEDULER,
  FETCH_SLACK_SCHEDULER,
  EDIT_SLACK_SCHEDULER,
  ADD_SLACK_SCHEDULER,
  DELETE_SLACK_SCHEDULER,
  CLEAR_SLACK_SCHEDULER,
  CLEAR_ALL,
  GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES,
  GET_SLACK_SCHEDULER_ADD_EMPLOYEES,
  GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES,
  SLACK_SCHEDULER_CLEAR_UPDATES,
} from "../constants/actions";

const initialState = {
  slack_bot_list: [],
  slack_schedulers: [],
  employee_search: [],
  pending: false,
  pageNumber: 1,
  updated: false,
  created: false,
  message: false,
};

export default function slackScheduler(state = initialState, action) {
  switch (action.type) {
    case PENDING_SLACK_SCHEDULER:
      return {
        ...state,
        pending: true,
      };
    case GET_SLACK_BOT_SELECT:
      return {
        ...state,
        slack_bot_list: action.payload,
      };
    case GET_SLACK_SCHEDULER:
      return {
        ...state,
        slack_schedulers: action.payload,
        pending: false,
      };
    case SLACK_SCHEDULER_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SLACK_SCHEDULER:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case EDIT_SLACK_SCHEDULER:
      return {
        ...state,
        updated: Math.random(),
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SLACK_SCHEDULER:
      return {
        ...state,
        updated: Math.random(),
        created: action.payload,
        pending: false,
      };
    case DELETE_SLACK_SCHEDULER:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case GET_SLACK_SCHEDULER_SEARCH_EMPLOYEES:
      return {
        ...state,
        pending: false,
        employee_search: action.payload,
      };
    case GET_SLACK_SCHEDULER_ADD_EMPLOYEES:
      return {
        ...state,
        message: action.payload,
        updated: Math.random(),
        pending: false,
      };
    case GET_SLACK_SCHEDULER_REMOVE_EMPLOYEES:
      return {
        ...state,
        message: action.payload,
        updated: Math.random(),
        pending: false,
      };
    case SLACK_SCHEDULER_CLEAR_UPDATES:
      return {
        ...state,
        updated: false,
        created: false,
      };
    case CLEAR_SLACK_SCHEDULER:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}
